import { z } from 'zod'
import { dataNominal, uuid } from './comum.js'
import { dinheiroNaoNegativo } from './contas-pagar.js'
import { acompanhamentoDaCampanha, margemEmApuracaoDaCampanha } from './campanhas.js'

export const referenciaDoGastoDv360 = z.object({
  campaignId: z.string().regex(/^[1-9][0-9]*$/),
  insertionOrderId: z.string().regex(/^[1-9][0-9]*$/).nullable(),
}).strict()
export const origemDoGastoDaLinha = z.discriminatedUnion('tipo', [
  z.object({ tipo: z.literal('nao_definido') }).strict(),
  z.object({ tipo: z.literal('manual') }).strict(),
  z.object({ tipo: z.literal('dv360'), referencias: z.array(referenciaDoGastoDv360).min(1).max(200) }).strict(),
  z.object({ tipo: z.literal('dv360_legado') }).strict(),
])
export const entradaDaOrigemPorLinha = z.object({
  versao: z.string().regex(/^[a-f0-9]{32}$/),
  linhas: z.array(z.object({
    itemCampanhaId: uuid,
    origem: origemDoGastoDaLinha,
    manual: z.object({
      valorAcumulado: dinheiroNaoNegativo,
      apuradoEm: dataNominal,
      confirmaValorMenor: z.boolean().optional(),
      confirmaDataAnterior: z.boolean().optional(),
    }).strict().nullable().optional(),
  }).strict()).max(500),
  motivo: z.string().trim().max(500).optional(),
}).strict()
export type EntradaDaOrigemPorLinha = z.infer<typeof entradaDaOrigemPorLinha>

export const configuracaoDaOrigemPorLinha = z.object({
  versao: z.string(),
  porLinha: z.boolean(),
  linhas: z.array(z.object({
    itemCampanhaId: uuid,
    origem: origemDoGastoDaLinha,
    manual: z.object({ valorAcumulado: z.string().nullable(), apuradoEm: dataNominal }).nullable(),
  })),
  campaigns: z.array(z.object({
    campaignId: z.string(), nome: z.string(), moeda: z.string(),
    ios: z.array(z.object({ insertionOrderId: z.string(), nome: z.string() })),
  })),
  historico: z.array(z.object({
    id: uuid, em: z.string(), por: z.string().nullable(), motivo: z.string().nullable(),
    linhas: z.array(z.object({ itemCampanhaId: uuid, origem: origemDoGastoDaLinha })),
  })),
})
export type ConfiguracaoDaOrigemPorLinha = z.infer<typeof configuracaoDaOrigemPorLinha>
export const previaDaOrigemPorLinha = z.object({
  antes: acompanhamentoDaCampanha, depois: acompanhamentoDaCampanha,
  margemEmApuracao: margemEmApuracaoDaCampanha, motivoNecessario: z.boolean(),
  confirmacoes: z.array(z.object({ itemCampanhaId: uuid, valorMenor: z.boolean(), dataAnterior: z.boolean() })),
})
export type PreviaDaOrigemPorLinha = z.infer<typeof previaDaOrigemPorLinha>
